<template>
  <div class="container">
    <div>
      <calculator-card :title="$t('新公司計算器')" :theme="`macau`">
        <NewCompany />
      </calculator-card>
      <calculator-card :title="$t('2021個人職業所得稅計算器')" :theme="`macau`">
        <ProfessionalIncomeTax />
      </calculator-card>
      <calculator-card :title="$t('2020所得補充稅模擬計算')" :theme="`macau`">
        <IncomeTax />
      </calculator-card>

      <calculator-card :title="$t('stamp_duty_transfer')" :theme="`macau`">
        <StampDuty />
      </calculator-card>

      <calculator-card
        :title="$t('transfer_real_estate_stamp_duty')"
        :theme="`macau`"
      >
        <TransferRealEstateStampDuty />
      </calculator-card>

      <calculator-card :title="$t('house_tax_calculator')" :theme="`macau`">
        <HouseTax />
      </calculator-card>
    </div>
  </div>
</template>

<script>
import StampDuty from "./components/calculators/stampDuty/StampDuty.vue";
import TransferRealEstateStampDuty from "./components/calculators/TransferRealEstateStampDuty.vue";
import HouseTax from "./components/calculators/houseRent/houseTax.vue";

export default {
  components: {
    StampDuty,
    TransferRealEstateStampDuty,
    HouseTax,
  },
};
</script>
